<template>
    <div class="abschluss-erfolgreich-box px-4 py-5 p-md-5 d-flex flex-column justify-content-center align-items-center">
        <grosser_haken_icon></grosser_haken_icon>
        <div class="mt-5 mb-4">
            <b>Vielen Dank für Ihr Vertrauen!<br>
            Der Online-Abschluss war erfolgreich.</b>
        </div>
        
        <div v-if="store.vertragsnummer" class="font-lg-links mb-3">
            <b>Ihre Vertragsnummer:</b> {{ store.vertragsnummer }}
        </div>

        <div class="abschluss-erfolgreich-info-box px-4 py-3 px-md-5 py-md-4">
            <div class="d-flex flex-row pb-3">
                <span class="me-3">
                    <info_icon_blau></info_icon_blau>
                </span>
                <div>
                    <b>Bitte beachten Sie:</b>
                </div>
            </div>
            Der Versicherungsschein wurde automatisch erstellt und von Ihrem Browser heruntergeladen. Bitte prüfen Sie Ihren Download-Ordner.
        </div>
        
        <!-- Button: Versicherungsschein erneut herunterladen -->
        <div v-if="store.vertragsnummer && store.secretstring" class="mt-4">
            <button 
                @click="handleErneuerDownload" 
                class="btn btn-vigo-1-500 rounded rounded-pill px-4 py-2"
                :disabled="isDownloading"
            >
                <span v-if="isDownloading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                {{ isDownloading ? 'Wird heruntergeladen...' : 'Versicherungsschein erneut herunterladen' }}
            </button>
        </div>

        <div class="font-lg-links mt-4">
            <b>Hinweis zur Verifizierung Ihrer E-Mailadresse:</b><br>
            Wir senden Ihnen eine E-Mail, die einen Bestätigungslink enthält. Mit  Bestätigung Ihrer E-Mailadresse erhalten Sie den Versicherungsschein auch per E-Mail.
        </div>
    </div> 
<!-- Erfolgreich Google Bewertung -->
    <div class="abschluss-erfolgreich-box px-4 py-5 p-md-5 d-flex flex-column align-items-center mt-4">
        <div class="font-lg-links w-100">
            <b>War der Abschluss leicht und verständlich?</b>
        </div>

        <div class="font-lg-links mt-2 w-100">
            Teilen Sie Ihre Erfahrung - Ihre Bewertung hilft uns und anderen Kunden.
        </div>

        <a href="https://g.page/r/CY6pjQr-ENVREAE/review" target="_blank" class="btn border-0 btn-vigo-3-500 font-base-links mt-4 rounded-pill px-4 py-2">
            Hier geht's zur Google Bewertung!
        </a>
    </div>

</template>

<script setup>
import { ref } from 'vue';
import { useRechnerStore } from '@/stores/rechner';
import { downloadVersicherungsschein } from '@/api/VertragService.js';
import grosser_haken_icon from '@/components/icons/grosser_haken_icon.vue';
import info_icon_blau from '@/components/icons/info_icon_blau.vue';

const store = useRechnerStore();
const isDownloading = ref(false);

const handleErneuerDownload = async () => {
    if (isDownloading.value) return;
    
    console.log('[AbschlussErfolgreich] Erneuter Download wird gestartet...');
    isDownloading.value = true;
    
    try {
        const result = await downloadVersicherungsschein(store.vertragsnummer, store.secretstring);
        
        if (!result.success) {
            console.error('[AbschlussErfolgreich] Download fehlgeschlagen:', result.error);
            alert('Fehler beim Herunterladen: ' + result.error);
        } else {
            console.log('[AbschlussErfolgreich] Download erfolgreich');
        }
    } catch (error) {
        console.error('[AbschlussErfolgreich] Unerwarteter Fehler:', error);
        alert('Ein unerwarteter Fehler ist aufgetreten');
    } finally {
        isDownloading.value = false;
    }
};
</script>